import { render } from "./TableRowRemove.vue?vue&type=template&id=fe039d68"
import script from "./TableRowRemove.vue?vue&type=script&lang=js"
export * from "./TableRowRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableRowRemove.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe039d68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe039d68', __exports__)) {
    api.reload('fe039d68', __exports__)
  }
  
  module.hot.accept("./TableRowRemove.vue?vue&type=template&id=fe039d68", () => {
    api.rerender('fe039d68', render)
  })

}


export default __exports__